import { JourneyIconButton } from 'ui/journey-builder/node-types/common';
import { NodeContainer } from 'ui/traveller-journey-builder/node-types/node-container';
import { TravellerJourneyNode } from 'ui/traveller-journey-builder/node-types/types';

type ActionType = 'journey_branch';

export const Node = (node: TravellerJourneyNode<ActionType>) => {
  return (
    <NodeContainer node={node}>
      <JourneyIconButton node={node} color="teal100" />
    </NodeContainer>
  );
};
